$(function () {
  // const $submitButton = $("#submit-button"); // 送信ボタンのセレクタを指定

  // // 初期状態で送信ボタンを無効化
  // $submitButton.prop("disabled", true);

  // // フォームのバリデーション設定
  // $("#form-input").validate({
  //   rules: {
  //     name: "required",
  //     name_kana: "required",
  //     age: "required",
  //     email: {
  //       required: true,
  //       email: true,
  //     },
  //     file: {
  //       required: true,
  //       extension: "pdf|doc|docx|xls|xlsx", // 許可する拡張子を指定
  //       filesize: 5 * 1024 * 1024, // 5MB以下
  //     },
  //     check: {
  //       required: true,
  //     },
  //   },
  //   messages: {
  //     name: "※未入力です",
  //     name_kana: "※未入力です",
  //     age: "※未入力です",
  //     email: {
  //       required: "※未入力です",
  //       email: "※正しい形式で入力してください",
  //     },
  //     file: {
  //       required: "ファイルを選択してください。",
  //       extension: "※許可されていないファイル形式です。",
  //       filesize: "ファイルサイズは5MB以下にしてください。",
  //     },
  //     check: "※利用規約に同意するにチェックを入れてください。",
  //   },
  //   // バリデーションが成功した場合に送信ボタンを有効化
  //   onkeyup: function (element) {
  //     $(element).valid(); // 入力されたフィールドのみバリデーションを実行
  //     if ($("#form-input").valid()) {
  //       $submitButton.prop("disabled", false); // ボタンを有効化
  //     } else {
  //       $submitButton.prop("disabled", true); // ボタンを無効化
  //     }
  //   },
  //   onclick: function (element) {
  //     $(element).valid(); // クリックされたフィールドのみバリデーションを実行
  //     if ($("#form-input").valid()) {
  //       $submitButton.prop("disabled", false); // ボタンを有効化
  //     } else {
  //       $submitButton.prop("disabled", true); // ボタンを無効化
  //     }
  //   },
  // });

  // // カスタムルールを追加
  // $.validator.addMethod(
  //   "filesize",
  //   function (value, element, param) {
  //     if (element.files.length > 0) {
  //       return element.files[0].size <= param;
  //     }
  //     return true;
  //   },
  //   "ファイルサイズが大きすぎます。" // デフォルトのエラーメッセージ
  // );

  // // 送信ボタンをクリックした際にバリデーションを実行
  // $("#form-input").on("submit", function (e) {
  //   if (!$(this).valid()) {
  //     e.preventDefault(); // バリデーションに失敗した場合は送信を防ぐ
  //     alert("入力内容にエラーがあります。修正してください。");
  //   }
  // });

  var swiper = new Swiper(".js-slider__marquee", {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 3000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
  var swiper = new Swiper(".js-slider__marquee_gallery", {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
  var swiper = new Swiper(".js-slider__marquee_members", {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
  var swiper = new Swiper(".js-slider__voice", {
    spaceBetween: 60,
    centeredSlides: false,
    speed: 600,
    autoplay: {
      delay: 2000,
    },
    loop: true,
    slidesPerView: "auto",
  });

  $(function () {
    $(".js-gnavi__toggle").on("click", function () {
      $(this).toggleClass("is-active");
      $(".l-header").toggleClass("is-active");
      $("body").toggleClass("is-lock");
      $(".js-gnavi").toggleClass("is-active");
    });
    $(".js-section__navi").on("click", function () {
      $(".js-gnavi__toggle").removeClass("is-active");
      $(".l-header").removeClass("is-active");
      $("body").removeClass("is-lock");
      $(".js-gnavi").removeClass("is-active");
    });

    $('input[type="file"]').on("change", function () {
      if (this.files && this.files.length > 0) {
        $(this).addClass("file-selected"); // ファイルが選択された場合にクラスを追加
      } else {
        $(this).removeClass("file-selected"); // ファイルが未選択の場合にクラスを削除
      }
    });

    $(window).on("scroll", function () {
      $(".js-section").each(function (index) {
        var scrollPosition = $(window).scrollTop();
        var sectionOffset = $(this).offset().top;
        var sectionHeight = $(this).outerHeight();
        var windowHeight = $(window).height();

        // セクションが画面内に入った場合
        if (
          scrollPosition + windowHeight / 2 > sectionOffset &&
          scrollPosition + windowHeight / 2 < sectionOffset + sectionHeight
        ) {
          $(".js-section__navi").removeClass("is-active");
          $(".js-section__navi").eq(index).addClass("is-active");
        }
      });
    });
  });

  $(window).on("load scroll resize", function () {
    $("html").addClass("is-loaded");
    var body = $("body");
    var offset = 400;

    if ($(this).scrollTop() > offset) {
      body.addClass("is-fixed--contents");
    } else {
      body.removeClass("is-fixed--contents");
    }
  });
});
const jsWPmv = document.querySelectorAll(".js-wp__mv");
jsWPmv.forEach(function (jsWPmv) {
  gsap.to(jsWPmv, {
    scrollTrigger: {
      trigger: jsWPmv,
      start: "top 80%",
      // end: "bottom -20%",
      scrub: false,
      once: true,
      // markers: true,
      toggleClass: "is-active",
    },
  });
});

const jsWP = document.querySelectorAll(".js-wp");
jsWP.forEach(function (jsWP) {
  gsap.to(jsWP, {
    scrollTrigger: {
      trigger: jsWP,
      start: "top 80%",
      end: "bottom -20%",
      scrub: false,
      once: true,
      toggleClass: "is-active",
    },
  });
});
